<template lang="html">
  <li class="tip">
    <a class="flex row justify-start col-33" :href="server + data.archivo" target="_blank"></a>
    <p class="flex" style="align-items: center;">{{ data.name }}
      <span v-if="$store.state.currentTips.some(tip => tip.id === data.id)" class="circle"></span>
    </p>
  </li>
</template>

<script lang="js">

import { mapGetters } from 'vuex'


export default {
  name: 'tip',
  props: ['data'],
  mounted() {

  },
  data() {
    return {

    }
  },
  methods: {

  },
  computed: {
    ...mapGetters({
      server: 'getServer'
    }),
  }
}
</script>

<style scoped>
.circle {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-color: rgb(255, 2, 2);
  border-radius: 50%;
  margin-left: 10px;
}

.tip {
  position: relative;
  height: 50px;
  line-height: 50px;
  width: 100%;
  padding: 0 10px;
  padding-left: 50px;
  background: #E6ECf1 url(/static/img/archive.svg) 15px center/20px no-repeat;
}

.tip p {
  width: 100%;
  background: url(/static/img/arrow-down.svg) calc(100% - 20px) center no-repeat;
}

.tip:hover {
  opacity: .5;
}

.tip a {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: none;
}

@media only screen and (max-width: 950px) {
  .tip p {
    width: 100%;
    background: url(/static/img/arrow-down.svg) calc(100% - 20px) center no-repeat;
    background-position-y: 17px;
    background-position-x: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
  }
}

@media only screen and (max-width: 500px) {
  .tip p {
    background-image: none;
  }
}</style>



// WEBPACK FOOTER //
// src/components/view-parts/area-tecnica/tip.vue